import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from "react-html-parser";
import Skeleton from "../Skeleton/Skeleton";
import ContentPanel from "../ContentPanel/ContentPanel";

const contentRenderer = (props) => {
  switch (props.contentType) {
    case "text/html": // HTML as a string
      return ReactHtmlParser(props.value);
    case "internal": // External HTML Template
      return (
        <ContentPanel
          skeleton={<Skeleton type={props.skeletonType ? props.skeletonType : "IFRAME"}/>}
          errorTemplate={
            <Skeleton
              type={props.skeletonType ? `${props.skeletonType}_ERROR` : "IFRAME_ERROR"}
            />
          }
          templateUrl={props.value}
        />
      );
    default:
      return null;
  }
};

export default contentRenderer;

contentRenderer.propTypes = {
  contentType: PropTypes.string,
  value: PropTypes.string, // can be a link or HTML string for parser
  skeletonType: PropTypes.oneOf([
    'IFRAME',
    'CAROUSEL',
    'DESKTOP_NAVIGATION_PANEL',
    'MAIN_PANEL',
    'CONTENT_PANEL',
    'FOOTER_PANEL',
    'LONG_CONTENT_PAGE',
    'SHORT_CONTENT'
  ])
};




// WEBPACK FOOTER //
// ./src/components/ContentRenderer/ContentRenderer.js